function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3;
var _excluded = ["disabled", "error", "icon", "look", "type"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../enums/accordion.js";
import "../../../enums/alert.js";
import "../../../enums/avatar.js";
import "../../../enums/breakpoints.js";
import "../../../enums/button.js";
import "../../../enums/code-editor.js";
import "../../../enums/colors.js";
import "../../../enums/combobox.js";
import "../../../enums/date.js";
import "../../../enums/drag-and-drop.js";
import "../../../enums/dialog.js";
import "../../../enums/divider.js";
import "../../../enums/dropdown.js";
import "../../../enums/fieldset.js";
import "../../../enums/font-icon.js";
import "../../../enums/fonts.js";
import "../../../enums/headings.js";
import "../../../enums/input.js";
import "../../../enums/keys.js";
import "../../../enums/list.js";
import "../../../enums/listbox.js";
import "../../../enums/loader.js";
import "../../../enums/margin.js";
import "../../../enums/option.js";
import "../../../enums/pill.js";
import "../../../enums/placements.js";
import "../../../enums/popout.js";
import "../../../enums/privacy.js";
import "../../../enums/radio-group.js";
import "../../../enums/status.js";
import "../../../enums/switch.js";
import "../../../enums/table.js";
import "../../../enums/tooltip.js";
import "../../../enums/transitions.js";
import "../../../enums/widths.js";
import "../../../utilities/color.js";
import 'date-fns';
import "../../../utilities/locale.js";
import "../../../hooks/use-prevent-keyboard-scrolling.js";
import { useRtl } from "../../../hooks/use-rtl.js";
import "../../../styles/styled-components/alert.js";
import "../../../styles/styled-components/animations.js";
import "../../../styles/styled-components/box-shadow.js";
import "../../../styles/styled-components/button.js";
import "../../../themes/alert.js";
import "../../../themes/button.js";
import "../../../themes/checkbox.js";
import "../../../themes/divider.js";
import "../../../themes/dropdown.js";
import "../../../themes/fieldset.js";
import "../../../themes/input.js";
import "../../../themes/list.js";
import "../../../themes/listbox.js";
import "../../../themes/loader.js";
import "../../../themes/option.js";
import "../../../themes/popout.js";
import "../../../themes/switch.js";
import { lightTheme } from "../../../themes/themes.js";
import "../../../themes/tooltip.js";
import "../../../styles/styled-components/font-face.js";
import "../../../styles/styled-components/global.js";
import { getInputAddonTheme } from "../../../styles/styled-components/input.js";
import "../../../styles/styled-components/list.js";
import "../../../styles/styled-components/listitem.js";
import "../../../styles/styled-components/media-queries.js";
import "../../../styles/styled-components/reset.js";
import "../../../styles/styled-components/outline.js";
import "../../../styles/styled-components/popout.js";
import "../../../styles/styled-components/screen-reader.js";
import "../../../styles/styled-components/switch.js";
import "../../../styles/styled-components/tooltip.js";
import { FontIcon } from "../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../atoms/alert/inline-alert/inline-alert.js";
import "../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import '@brandfolder/utilities';
import "../../atoms/button/close-button/close-button.js";
import "../../atoms/button/color-button/color-button.js";
import "../../atoms/button/icon-button/icon-button.js";
import "../../atoms/button/standard-button/standard-button.js";
import "../../atoms/loader/circle-loader/circle-loader.js";
import "../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../atoms/divider/standard-divider/standard-divider.js";
import "../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../atoms/heading/standard-heading/standard-heading.js";
import "../../atoms/label/standard-label/standard-label.js";
import "../../atoms/link/button-link/button-link.js";
import "../../atoms/link/standard-link/standard-link.js";
import "../../atoms/popout/standard-popout/standard-popout.js";
import "../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../atoms/table/standard-table/caption.js";
import "../../atoms/table/standard-table/tbody.js";
import "../../atoms/table/standard-table/tr-empty.js";
import "../../atoms/table/standard-table/td.js";
import "../../atoms/table/standard-table/tr.js";
import "../../atoms/table/standard-table/table.js";
import "../../atoms/table/standard-table/tfoot.js";
import "../../atoms/table/standard-table/th.js";
import "../../atoms/table/standard-table/thead.js";
import "../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../atoms/text/help-text/help-text.js";
import "../../atoms/text/standard-text/standard-text.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var TextfieldIconTypes;
(function (TextfieldIconTypes) {
  TextfieldIconTypes["Left"] = 'left';
  TextfieldIconTypes["Right"] = 'right';
})(TextfieldIconTypes || (TextfieldIconTypes = {}));
var BaseTextfieldIcon = function BaseTextfieldIcon(props) {
  var _classnames;
  var disabled = props.disabled,
    error = props.error,
    icon = props.icon,
    look = props.look,
    type = props.type,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useRtl = useRtl(),
    dir = _useRtl.dir;
  return /*#__PURE__*/React.createElement(FontIcon, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-textfield__icon': true,
      'bf-textfield__icon--disabled': disabled,
      'bf-textfield__icon--error': !!error
    }, _defineProperty(_classnames, "bf-textfield__icon--look-".concat(look), look), _defineProperty(_classnames, "bf-textfield__icon--type-".concat(type), type), _defineProperty(_classnames, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className)), _classnames)),
    dir: dir,
    icon: icon
  }));
};
var left = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  left: 15px;\n\n  &[dir='rtl'] {\n    left: unset;\n    right: 15px;\n  }\n"])));
var right = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  right: 15px;\n\n  &[dir='rtl'] {\n    left: 15px;\n    right: unset;\n  }\n"])));
var Icon = styled(BaseTextfieldIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", ";\n  top: 17px;\n  ", "\n"])), function (_ref) {
  var type = _ref.type;
  return type === TextfieldIconTypes.Left ? left : right;
}, function (_ref2) {
  var disabled = _ref2.disabled,
    error = _ref2.error,
    look = _ref2.look;
  return getInputAddonTheme({
    disabled: disabled,
    error: error,
    look: look
  });
});
var TextfieldIcon = function TextfieldIcon(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Icon, _extends({}, props)));
};
export { TextfieldIcon, TextfieldIconTypes };